import { Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import TireHistoryTable from "components/Table/Logistic/Tire/TireHistoryTable";
import { createGraphQLClientWithMiddleware } from "services/graphqlClient";
import {
  useVehicleFindUniqueQuery,
  VehicleFindUniqueQuery,
} from "generated/vehicle";

const TireHistoryTab = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const graphQLClient = createGraphQLClientWithMiddleware("sales");

  const { data, isSuccess } = useVehicleFindUniqueQuery<VehicleFindUniqueQuery>(
    graphQLClient,
    {
      vehicleFindUniqueId: id ? parseInt(id) : -1,
    },
    {
      enabled: !!id,
      cacheTime: 0,
    }
  );

  return (
    <>
      <Typography variant="h5" mb={2}>
        {t("logistic.tire.history.index")}
      </Typography>
      {isSuccess && (
        <TireHistoryTable
          referenceVehicleUniqueId={data?.VehicleFindUnique?.unique_id}
        />
      )}
    </>
  );
};

export default TireHistoryTab;
